import React, { useState, useEffect } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";

import loginLogo from "../assets/img/logo.png";
import Image from "../assets/img/verified.jpeg";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import useRequest from "../hooks/useRequest";
import { toast } from "react-toastify";

const EmailVerify = () => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const { token } = useParams();
  const { response, request } = useRequest();

  const handleVerifyEmail = async () => {
    if (token) {
      setLoading(true);

      request("POST", "verifyRegistration", { managerId: token });
    }
  };

  useEffect(() => {
    if (response) {
      if (response.status == "success") {
        toast.success(response.message);
        history.push("/login");
      }
    }
  }, [response]);

  return (
    <div className="ms-body ms-primary-theme ms-logged-out">
      <main className="body-content">
        <div className="ms-content-wrapper ms-auth">
          <Row>
            <Col md={5}>
              <div className="ms-auth-bg">
                <img src={loginLogo} />
              </div>
            </Col>
            <Col>
              <div className="verify-email">
                <div className="verify-card">
                  <center>
                    <img src={Image} />
                    <h2>Thank You!</h2>
                  </center>

                  <p className="verify-greeting">Dear Partner</p>
                  <h2>Congratulations!!</h2>
                  <p className="verify-subtitle">
                    Your restaurant has been verified successfully.
                  </p>

                  <p className="verify-message">
                    Download the Sortyfy Vendors App to make the restaurant live
                    on Sortyfy Guest App: -
                  </p>

                  <ul className="verify-list">
                    <li>
                      You can amend or change the restaurant information, if
                      required.
                    </li>
                    <li>Upload good pictures to attract more footfall.</li>
                    <li>Upload the Events &amp; Party Promotions.</li>
                    <li>
                      Amend the discounts, offer attractive discount offers to
                      maximise business.
                    </li>
                    <li>
                      Change the menu if required to get the better rating on
                      App.
                    </li>
                    <li>
                      Update the Bank Details to receive the instant payments.
                    </li>
                    <li>Download the contract copy for your office records.</li>
                    <li>
                      Update the Managers Information who can receive the
                      bookings.
                    </li>
                    <li>Cross check the address and location.</li>
                  </ul>

                  <div className="verify-download">
                    <p className="verify-download-title">Download</p>
                    <div className="verify-download-buttons">
                      <a
                        target="_blank"
                        href={`https://play.google.com/store/apps/details?id=com.sortyfy.app`}
                        className="verify-btn verify-btn--android"
                      >
                        Android
                      </a>
                      <a
                        href={`https://apps.apple.com/app/sortyfy/id6739164108`}
                        target="_blank"
                        className="verify-btn verify-btn--apple"
                      >
                        Apple
                      </a>
                      <a
                        href={` https://partners.sortyfy.com/login`}
                        target="_blank"
                        className="verify-btn verify-btn--web"
                      >
                        Web Panel
                      </a>
                    </div>
                  </div>

                  <p className="verify-cta">
                    Let’s Start the Sortyfy Successful Journey!!
                  </p>
                  <p className="verify-thanks">Thanks</p>
                  <div className="verify-footer">
                    <p className="verify-team">Sortyfy Team</p>
                    <p className="verify-contact">Call Us: +91 95094 46022</p>
                    <p className="verify-contact">Write Us: info@sortyfy.com</p>
                  </div>

                  
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </main>
    </div>
  );
};

export default EmailVerify;
